import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { TaxStatus } from './tax-status.interface';

export class TaxStatusService {
   async getTaxStatuses() {
      return await http.get<Array<TaxStatus>>(`/tax-statuses`, cacheFirstConfig).then((response) => response.data);
   }
}
